import React, { forwardRef } from 'react';

interface XProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const X = forwardRef<HTMLElement, XProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-xmark ${classes || ''}`} style={style}></i>
  );
});

X.displayName = 'X';